import { get, postJson } from "@/services/http/backend";

export interface NoticeInfo {
  dateCreated: string;
  lastUpdated: string;
  id: number;
  title: string;
  content: string;
  read: boolean;
  reader: any;
  companyId: number;
}

export async function getNoticeInfoList() {
  return get<NoticeInfo[]>("/notice_info/list");
}

export async function readNoticeInfo(ids: number[]) {
  return postJson(`/notice_info/batch_read`, {
    ids,
  });
}
